<template>
  <base-page-layout>
    <v-layout class="page-container pa-0" row wrap fill-height align-center>
      <v-flex xs12 sm6 class="text-block">
        <h1 class="mb-4">Plataforma em manutenção!</h1>
        <p class="mb-2">
          Estamos trabalhando em uma atualização para proporcionar uma experiência ainda melhor, infelizmente nesse momento não será possível acessar esta
          página
        </p>
        <p>Pedimos desculpas por qualquer inconveniente que isso possa causar e agradecemos pela compreensão.</p>
        <span
          >Previsão de retorno às <b>{{ maintenanceReturnForecast }} horas</b></span
        >
      </v-flex>
      <v-flex xs12 sm6 class="image">
        <img :src="require('@/assets/maintenance.svg')" class="responsive-image" />
      </v-flex>
    </v-layout>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    BasePageLayout,
  },
  computed: {
    ...mapGetters(['maintenanceReturnForecast', 'maintenanceModules']),
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  height: calc(100dvh - 141px);

  img {
    max-width: 500px;
  }

  .text-block {
    padding: 0 70px;
  }

  h1 {
    color: $cinza-d10;
    font-size: 40px;
    font-weight: 700;
    line-height: 120%;
  }

  p {
    font-size: 18px;
    font-weight: 400;
    line-height: 120%;
    color: $cinza-0;
  }

  span {
    font-size: 18px;
    font-weight: 400;
    line-height: 120%;
    color: $cinza-d10;

    b {
      color: $marca-0-l30;
    }
  }
  .image {
    text-align: center;
  }
}
</style>
